<script setup lang="ts">
import { TableProps } from '~/components/cms/Table/Table.vue'

const props = defineProps<TableProps>()
</script>

<template>
  <section class="table container" data-testid="stacked-table">
    <div class="stacked-table__table">
      <table v-if="table">
        <thead>
          <tr>
            <th v-for="(cell, index) in table.rows[0].cells" :key="index">
              <TableCell v-bind="cell" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in table.rows.slice(1)" :key="index">
            <td v-for="(cell, cellIndex) in row.cells" :key="cellIndex">
              <TableCell v-bind="cell" />
            </td>
          </tr>
        </tbody>
      </table>
      <Markdown v-if="underTableText" class="stacked-table__underText" :content="underTableText" />
    </div>

    <div v-if="table" class="stacked-table__list">
      <div v-for="(row, index) in table.rows.slice(1)" :key="index" class="row">
        <div class="column">
          <div class="stacked-table__list__header">
            <TableCell v-bind="table.rows[0].cells[0]" />
          </div>
          <div>
            <TableCell v-bind="row.cells[0]" />
          </div>
        </div>
        <div class="column">
          <div v-for="(cell, cellIndex) in table.rows[index].cells" :key="cellIndex">
            <div v-if="cellIndex > 0" class="stacked-table__list__header">
              <TableCell v-bind="table.rows[0].cells[cellIndex]" />
            </div>
            <div v-if="cellIndex > 0" class="stacked-table__list__row">
              <TableCell v-bind="row.cells[cellIndex]" />
            </div>
          </div>
        </div>
      </div>
      <Markdown v-if="underTableText" class="stacked-table__underText" :content="underTableText" />
    </div>
  </section>
</template>

<style lang="postcss">
.table {
  margin-bottom: var(--component-space);

  .row {
    display: flex;
    border-top: 1px solid var(--text-disabled);
    border-bottom: 1px solid var(--text-disabled);
    padding-block: var(--space-60);
  }

  /* Create two equal columns that sits next to each other */
  .column {
    flex: 50%;
  }
}

.stacked-table__table {
  display: none;
  @media (--tablet) {
    display: block;
  }

  table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;

    th {
      text-align: left;
      padding-bottom: var(--space-30);
    }

    td {
      padding-block: var(--space-60);
    }

    tr {
      border-bottom: 1px solid var(--text-disabled);
      vertical-align: top;
    }
  }
}

.stacked-table__list {
  display: block;
  @media (--tablet) {
    display: none;
  }
}

.stacked-table__underText {
  font-size: var(--text-small);
}

.stacked-table__list__header {
  margin-bottom: var(--space-30);
}

.stacked-table__list__row {
  margin-bottom: var(--space-50);
}

.stacked-table__list__learnMore {
  text-align: right;
}
</style>
